import RenderManager from "../../rendering/render-manager";
import SlideManager from "../slide-manager";
import TransformModifiers from "../../objects/transform-modifiers";

function getObjectParent(object) {
    let parent = object.parent;

    if (!parent) return null;

    if (TransformModifiers.isTransformModifier(parent)) {
        return getObjectParent(parent);
    }

    return parent;
}

function getRootObject(object) {
    while (true) {
        let parent = getObjectParent(object);
        if (!parent || parent === RenderManager.activeScene) break;

        object = parent;
    }

    return object;
};

function getQuizMovableObject(object) {
    const slideQuiz = SlideManager.currentSlide.slideQuiz;
    const movableUuids = new Set(slideQuiz.meshes.map(mesh => mesh.uuid));

    while (true) {
        if (movableUuids.has(object.uuid)) {
            return object;
        }

        let parent = getObjectParent(object);
        if (!parent || parent === RenderManager.activeScene) break;

        object = parent;
    }

    return null;
}

function getMovableObject(object) {
    const slideQuiz = SlideManager.currentSlide.slideQuiz;

    if (slideQuiz && slideQuiz.type === 'plopQuiz') {
        return getQuizMovableObject(object);
    } else {
        return getRootObject(object);
    }
}

const intersections = [];

function raycastObject(raycaster, mousePos) {
    raycaster.setRayPos(mousePos);
    raycaster.setRadius(0.1);
    raycaster.raycastObject(RenderManager.activeScene, intersections);

    const intersection = intersections.find(({ object }) => {
        if ("overridePicker" in object && object.overridePicker)
            object = object.overridePicker;

        if (object.isScalpelPlane || object.isTemporary) return false;

        return true;
    });

    const object = intersection ? intersection.object : null;

    intersections.length = 0;

    return object;
}

function selectObject(raycaster, event) {
    let object = null;

    if (Q3.selected && Q3.selected.isObject3D) {
        object = Q3.selected;
    } else {
        object = raycastObject(raycaster, event);
    }

    if (object) {
        object = getMovableObject(object);
    }

    return object;
}

export default selectObject;
